/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_FirstpassInputs */

const en_fw_bm_col_firstpass = /** @type {(inputs: Fw_Bm_Col_FirstpassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First pass`)
};

const id_fw_bm_col_firstpass = /** @type {(inputs: Fw_Bm_Col_FirstpassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lolos ke-1`)
};

/**
* | output |
* | --- |
* | "First pass" |
*
* @param {Fw_Bm_Col_FirstpassInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_firstpass = /** @type {((inputs?: Fw_Bm_Col_FirstpassInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_FirstpassInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_firstpass(inputs)
	return en_fw_bm_col_firstpass(inputs)
});